import React, { useEffect, useState } from 'react';
import { formatCurrency } from '../../utils/numberUtils.js';
import { getCashBackMovimentosPorPessoa } from '../../services/pedidos/CashBackService.js';
import ModalContainer from '../../components/modalForm/ModalContainer.js';
import ModalBody from '../../components/modalForm/ModalBody.js';
import ModalFooter from '../../components/modalForm/ModalFooter.js';
import ModalHeader from '../../components/modalForm/ModalHeader.js';

const formatarDataHora = (valor) => {
    if (!valor) return '';

    const data = new Date(valor);
    if (Number.isNaN(data.getTime())) return '';

    return data.toLocaleString('pt-BR');
};

const ModalCashBackMov = ({ show, onHide, cliente }) => {
    const [movimentos, setMovimentos] = useState([]);
    const [carregando, setCarregando] = useState(false);

    const pessoaId = cliente?.pessoaId || cliente?.pessoa?.id;

    useEffect(() => {
        const carregarMovimentos = async () => {
            if (!show || !pessoaId) {
                setMovimentos([]);
                return;
            }

            setCarregando(true);
            try {
                const result = await getCashBackMovimentosPorPessoa(pessoaId);
                setMovimentos(result || []);
            } catch (error) {
                console.error('Erro ao buscar movimentações de cashback:', error);
                setMovimentos([]);
            } finally {
                setCarregando(false);
            }
        };

        carregarMovimentos();
    }, [show, pessoaId]);

    if (!show) return null;

    return (
        <ModalContainer show={show} largura='650px' zIndex={1070}>
            <ModalHeader>
                <h5 className="modal-title">Movimentações de Cashback</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
            </ModalHeader>
            <ModalBody>
                <div style={{ marginBottom: '10px' }}>
                    <strong>Cliente: </strong>{cliente?.pessoa?.nome || ''}
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Pedido</th>
                            <th>Status</th>
                            <th className="direita">Valor Mov.</th>
                            <th className="direita">Cashback</th>
                        </tr>
                    </thead>
                    <tbody>
                        {carregando && (
                            <tr>
                                <td colSpan="5">Carregando...</td>
                            </tr>
                        )}
                        {!carregando && movimentos.length === 0 && (
                            <tr>
                                <td colSpan="5">Nenhuma movimentação encontrada.</td>
                            </tr>
                        )}
                        {!carregando && movimentos.map((mov) => (
                            <tr key={mov.id}>
                                <td>{formatarDataHora(mov.dataMov)}</td>
                                <td>{mov.pedidoId}</td>
                                <td>{mov.statusDescricao}</td>
                                <td className="direita">{formatCurrency(mov.valorMov)}</td>
                                <td className="direita">{formatCurrency(mov.valorCashBack)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary" onClick={onHide}>
                    Fechar
                </button>
            </ModalFooter>
        </ModalContainer>
    );
};

export default ModalCashBackMov;
